import React, { useMemo, useRef, useState } from 'react';
import { View, StyleSheet, Dimensions, TouchableOpacity, Modal, ScrollView as RNScrollView, Image, Platform } from 'react-native';
import { useSelector } from 'react-redux';
import { convertFromUtc, Props } from './Clock.utils';
import I18n from '../i18n/I18n.component';
import Typography from '../Typography/Typography.component';
import ClockDisplay from './ClockDisplay/ClockDisplay.component';
import RecordCard from './Record/Record.component';
import { Record } from './Record/Record.component';
import colors from '../../../config/colors';
import { getServerDateTime } from '../../../store/selectors/dateTime.selectors';
import { i18nService } from '../../../services/i18n.service';
import Button from '../../../components/shared/Buttons/Button.component';
import ActionButton from '../Buttons/ActionButton.container';
import ImageIcon from '../Icon/ImageIcon.component';
import SelectFilter from './EventsAndProjectsSelect/EventsAndProjectsSelect.container';
import { useNavigation } from '@react-navigation/native';
import { ScrollView } from 'react-native-gesture-handler';
import BottomSheet from 'reanimated-bottom-sheet';
import moment from 'moment';
import { toNumber } from 'lodash';
import { 
	EventName,
	 logEvent 
} from '../../../services/analyticsAndLogs.service';

const ClockReportMobileComponent = ({
	initialTime,
	shiftTime,
	totalReported,
	activeDayTotalReported,
	reachedMax,
	onPressEntry,
	onPressExit,
	onPressReportExit,
	projectsOptions,
	eventsOptions,
	onSelectProjectOrEvent,
	selectedItem,
	defaultProjectOption,
	defaultEventOption,
	label,
	canReportFullDay,
	disableButtons,
	disableEntryButton,
	report101warning,
	selectedItemType,
	handleOpenOptions,
	eventPlaceholdar,
	currentRunnigWorkLog,
	handleAddNewLog,
	openProjectPicker,
	records,
	onDelete,
	onEdit,
	compact,
	standardHours,
	canEdit
}: Props) => {
	const navigation = useNavigation();
	const currentServerTime = useSelector(getServerDateTime);
	const todayDate = convertFromUtc(currentServerTime, false, true, 'YYYY-MM-DDTHH:mm', 'DD/MM/YYYY');
	const isToday = todayDate === moment().format('DD/MM/YYYY');
	const convertToHoursFormat = (time: any) => {
		if (!time) return '00:00';
		const [hours, minutes] = time.split(':');
		return `${toNumber(hours).toLocaleString()}:${minutes}`;
	};
	const standard = useMemo(() => {
		return convertToHoursFormat(standardHours?.fixHours);
	}, [standardHours]);
	const sheetRef = useRef<any>(null);
	const [isSheetOpen, setIsSheetOpen] = useState(false);
	const windowHeight = Dimensions.get('window').height;

	const convertHoursFormat = (value: any, format?: string, withPrefix?: boolean) => {
		if (value) {
			if (format === 'HH:mm') {
				const hours = `${Math.floor(value / 60)?.toLocaleString()}`;
				const mins = Math.floor(value % 60);
				const minutes = mins < 10 ? `0${mins}` : `${mins}`;
			return `${hours}:${minutes}`;
			}
			return `${(value / 60).toFixed(2)}`;
		}
		return '0:00';
	};

	const convertMinutesToHours = (value: any, format?: string) => {
		if (value) {
			if (format === 'HH:mm') {
				const hours = `${Math.floor(value / 60)?.toLocaleString()}`;
				const minutes =
					value % 60 !== 0
						? value % 60 < 10
							? `0${value % 60}`
							: `${value % 60}`
						: '00';
				return `${hours}:${minutes}`;
			}
			return `${(value / 60).toFixed(2)}`;
		}
		return '';
	};

	const Wrapper = compact ? View : ScrollView;
	const wrapperProps = compact
		? { style: [styles.contentBlock, { width: '100%' }], nativeID: 'clockReport' }
		: { contentContainerStyle: [styles.contentBlock, { flexGrow: 1 }], style: { width: '100%', flex: 1 }, nativeID: 'clockReport', showsVerticalScrollIndicator: true };

	return (
		<Wrapper {...wrapperProps}>
			<View style={styles.logoBlock}>
				{compact ? (
					<ActionButton onPress={() => setIsSheetOpen(true)}>
						<ImageIcon name={'chevronLeft'} width={16} height={16} />
						<I18n size={15} weight='normal' color='primary'>
							general.startDay
						</I18n>
					</ActionButton>
				) : <View />}
				<ImageIcon 
					name={'clockInLogo'}
					width={108}
					height={30}
				/>
			</View>
			<View nativeID='detailsHeader' style={styles.detailsHeader}>
				{!disableButtons.disable ? (
					<View nativeID='FiltersHolder' style={styles.FiltersHolder}>
						{eventsOptions.length ? (
							<SelectFilter
								canReportFullDay={canReportFullDay}
								options={eventsOptions}
								isProject={false}
								placeHolder={eventPlaceholdar}
								onSubmit={onSelectProjectOrEvent}
								disabled={selectedItemType === 'projects'}
								onOpen={(isOpen: boolean) => handleOpenOptions(isOpen, 'events')}
								defaultOption={defaultEventOption}
								currentRunnigWorkLog={currentRunnigWorkLog}
							/>
						) : null}
						{projectsOptions.length ? (
							<SelectFilter
								canReportFullDay={canReportFullDay}
								options={projectsOptions}
								isProject={true}
								placeHolder={defaultProjectOption.name ? defaultProjectOption.name : 'menu.projects'}
								onSubmit={onSelectProjectOrEvent}
								disabled={selectedItemType === 'events'}
								onOpen={(isOpen: boolean) => handleOpenOptions(isOpen, 'projects')}
								defaultOption={defaultProjectOption}
								currentRunnigWorkLog={currentRunnigWorkLog}
							/>
						) : null}
					</View>
				) : null}
				
			</View>
			<View style={Platform.select({ native: { marginBottom: 16 } })}>
				<ClockDisplay
					isRunning={!!initialTime}
					initialTime={initialTime}
					shiftTime={shiftTime}
					totalReported={activeDayTotalReported}
					reachedMax={reachedMax}
					enterTime={currentRunnigWorkLog?.enterTime}
					isFullDayReport={disableButtons.disable}
				/>
			</View>
			{label ? (
				<Typography
					size={14}
					color='primaryDarkBlue'
					weight='normal'
					style={{ marginVertical: 10, textAlign: 'center' }}
				>
					{label}
				</Typography>
			) : null}
			{!disableButtons.disable ? (
				<View nativeID='ButtonsHolder' style={styles.ButtonsHolder}>
					{initialTime ? (
						<>
							<ActionButton onPress={onPressExit} overrideStyle={styles.filledButton}>
								<I18n size={16} weight='normal' color='white'>
									general.exit
								</I18n>
								<ImageIcon name='stop' size={16} color='white' style={{ marginLeft: 4 }} />
							</ActionButton>
							{projectsOptions.length ? (
								<ActionButton onPress={() => openProjectPicker?.()} overrideStyle={styles.outlinedButton}>
									<Typography size={16} weight='normal' color='primary'>
										{'+ '}
									</Typography>
									<I18n size={16} weight='normal' color='primary'>
										menu.projects
									</I18n>
								</ActionButton>
							) : null}
						</>
					) : (
						<>
							<ActionButton
								onPress={onPressEntry}
								disabled={disableEntryButton}
								overrideStyle={[styles.filledGreenButton, disableEntryButton && { opacity: 0.3 }]}
							>
								<I18n size={16} weight='normal' color='white'>
									general.enterence
								</I18n>
								<ImageIcon name='play' width={18} height={18} color='white' style={{ marginLeft: 4 }} />
							</ActionButton>
							<ActionButton onPress={onPressReportExit ?? onPressExit} overrideStyle={styles.outlinedButton}>
								<I18n size={16} weight='normal' color='primary'>
									general.reportExit
								</I18n>
								<ImageIcon name='clockLoginPrimary' width={18} height={18} color='primary' style={{ marginLeft: 4 }} />
							</ActionButton>
						</>
					)}
				</View>
			) : (
				<View
					style={{
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
						height: 100,
						marginTop: 10,
					}}
				>
					<I18n size={16} weight='normal' color='clockRecordBlue'>
						{`${i18nService.translate('general.youAreNowReportingEvent')} `}
					</I18n>
					<I18n size={16} font='medium' color='titlePrimary'>
						{`${i18nService.translate(disableButtons.eventName)} - יום מלא`}
					</I18n>
				</View>
			)}
			{compact ? (
				<>
					<Modal
						visible={isSheetOpen}
						transparent
						animationType='none'
						onRequestClose={() => sheetRef.current?.snapTo(0)}
					>
						<TouchableOpacity
							activeOpacity={1}
							onPress={() => sheetRef.current?.snapTo(0)}
							style={styles.sheetBackdrop}
						/>
					<BottomSheet
						ref={sheetRef}
						initialSnap={1}
						snapPoints={[0, windowHeight * 0.7]}
						enabledContentGestureInteraction={false}
						enabledInnerScrolling={true}
						onCloseEnd={() => setIsSheetOpen(false)}
						renderHeader={() => (
							<View style={styles.sheetHeader}>
								<View style={styles.sheetHandle} />
								<View style={styles.sheetTitleRow}>
									<TouchableOpacity onPress={() => sheetRef.current?.snapTo(0)}>
										<Typography size={18} color='darkGrey'>✕</Typography>
									</TouchableOpacity>
									<Typography size={16} font='medium' color='primaryDarkBlue'>
										פירוט החתמות
									</Typography>
									<View style={{ width: 24 }} />
								</View>
							</View>
						)}
						renderContent={() => (
							<View style={styles.sheetContent}>
								<View style={styles.headerCard}>
									<Typography size={14} font='medium' color='primaryDarkBlue' style={Platform.select({ ios: { marginBottom: 16 }, android: { marginBottom: 16 } })}>
										{`היום - ${convertFromUtc(currentServerTime, false, true, 'YYYY-MM-DDTHH:mm', 'DD/MM/YYYY')}`}
									</Typography>
									<View style={{ flexDirection: 'row', alignItems: 'center', ...Platform.select({ web: { gap: 4 } }) }}>
										<Typography size={14} color='clockRecordBlue' font='medium' style={Platform.select({ ios: { marginRight: 4 }, android: { marginRight: 4 } })}>
											{convertHoursFormat(totalReported * 60, 'HH:mm', false)}
										</Typography>
										<Typography size={14} color='greyText' weight='normal'>
											{`/${standard}`}
										</Typography>
									</View>
								</View>
								{records && records.length ? (
									<View style={{ flex: 1, minHeight: 0, ...Platform.select({ web: { gap: 16 } }) }}>
										<RNScrollView
											nestedScrollEnabled={true}
											showsVerticalScrollIndicator={false}
											style={styles.sheetRecordsList}
										>
											{records.map((record: Record) => (
												<View key={record.workLogId} style={styles.recordRow}>
													<View style={styles.header}>
														<I18n size={14} font='medium' color='titlePrimary'>
															{record.eventName || 'report'}
														</I18n>

														{canEdit && (
															<TouchableOpacity
																style={styles.editCell}
																onPress={() => {
																	setIsSheetOpen(false);
																	// ios cannot agree 2 modals at the same time, so we need to delay the opening of the edit modal until the bottom sheet is fully closed
																	setTimeout(() => onEdit(record.workLogId, record), 400);
																}}
															>
																<ImageIcon name='pencilEdit' />
															</TouchableOpacity>
														)}											
													

													</View>
													<View style={styles.body}>
														<I18n
															size={14}
															font={record.total ? 'medium' : 'normal'}
															color={'clockRecordBlue'}
															style={{ opacity: record.total ? 1 : 0.3, marginLeft: 8 }}
														>
															{record.total
																? convertMinutesToHours(record.total, 'HH:mm')
																: '00:00'}
														</I18n>
														<ImageIcon
															name='chevronLeft'
															width={16}
															height={16}
															style={{ marginLeft: 8 }}
															color='darkGrey'
														/>
														<I18n
															size={14}
															weight='normal'
															color={'clockRecordBlue'}
															style={{ opacity: 1 , marginLeft: 8 }}
														>
															{record.exitTime
																? convertFromUtc(record.exitTime, true)
																: '00:00'}
														</I18n>
														<I18n
															size={14}
															weight='normal'
															color={'greyText'}
															style={{ marginLeft: 8 }}
														>
															-
														</I18n>
														<I18n
															size={14}
															weight='normal'
															color={
																!isToday && record.enterTime === '00:00'
																	? 'red'
																	: 'clockRecordBlue'
															}
															style={{marginLeft: 8 }}
														>
															{record.enterTime
																? convertFromUtc(record.enterTime, true)
																: '00:00'}
														</I18n>
													</View>
												</View>
											))}

										</RNScrollView>
									</View>
								) : (
									<View style={styles.emptyState}>
										<ImageIcon name='noRecords' width={120} height={120}/>
										<I18n size={14} color='darkGrey' weight='normal' style={Platform.select({ ios: { marginTop: 24 }, android: { marginTop: 24 } })}>
											reportView.noWorklogsToday
										</I18n>
									</View>
								)}
							</View>
						)}
					/>
					</Modal>
				</>			) : (
			<>
			{/* divider */}
			<View style={{ width: '100%', height: 0, borderWidth: 1, borderColor: '#EBF0F6', marginBottom: 12 }} />

			<View style={{ flex: 1, width: '100%', ...Platform.select({ web: { gap: 16 } }) }}>
				<View style={styles.sectionHeaderRow}>
					<View style={{ flexDirection: 'row', alignItems: 'center', ...Platform.select({ web: { gap: 4 } }) }}>
						<Typography size={12} color='clockRecordBlue' font='medium' style={Platform.select({ ios: { marginRight: 4 }, android: { marginRight: 4 } })}>
							{convertHoursFormat(totalReported * 60, 'HH:mm', false)}
						</Typography>
						<Typography size={12} color='greyText' weight='normal'>
							{`/${standard}`}
						</Typography>
					</View>
					<Typography size={14} color='primaryDarkBlue' font='medium'>
						{`${i18nService.translate('general.startDay')} - ${isToday ? 'היום' : todayDate}`}
					</Typography>
				</View>
				{records && records.length ? (
					<>
						{records.map((record: Record) => (
							<RecordCard
								onDelete={onDelete}
								onEdit={onEdit}
								key={record.workLogId}
								record={record}
							/>
						))}
					</>
				) : (
					<View style={styles.emptyState}>
						<ImageIcon name='noRecords' width={120} height={120}/>
						<I18n size={14} color='greyText' weight='normal'>
							reportView.noWorklogsToday
						</I18n>
					</View>
				)}
			</View>
			{report101warning && (
				<View style={styles.report101Container}>
					<View style={styles.report101ActionsContainer}>
						<Button
							buttonStyle={StyleSheet.flatten([
								styles.report101Button,
								{
									backgroundColor: 'red',
								},
							])}
							onPress={() => {
								logEvent({
									eventName: EventName.report101Button,
									data: {},
								});
								navigation.navigate('form101');
							}}
						>
							<I18n size={14} weight={'normal'} color={'white'}>
								reportView.wageDataSummary.report101Button
							</I18n>
						</Button>
					</View>
					<View style={styles.report101Text}>
						<I18n
							style={{ textAlign: 'center' }}
							size={16}
							weight={'normal'}
							color={'red'}
						>
							reportView.wageDataSummary.report101TextWarning
						</I18n>
					</View>
				</View>
			)}
			</>
			)}
		</Wrapper>
	);
};

const styles = StyleSheet.create({
	header: {
		flexDirection: 'row-reverse',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
	},
	contentBlock: {
		padding: 16,
		backgroundColor: colors.white,
		borderRadius: 8,
		width: '100%',
		alignItems: 'center',
		...Platform.select({
			web: { gap: 16, boxShadow: '2px 2px 16px 0 rgba(0, 0, 0, 0.04)' },
			ios: { shadowColor: '#000', shadowOffset: { width: 2, height: 2 }, shadowOpacity: 0.04, shadowRadius: 16 },
			android: { elevation: 2 },
		}),
	},
	logoBlock: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
		...Platform.select({ native: { marginBottom: 16 } }),
	},
	detailsHeader: {
		width: '100%',
		marginBottom: 20,
		alignSelf: 'flex-start',
	},
	FiltersHolder: {
		zIndex: 11111,
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		height: 42,
		paddingHorizontal: 50,
		alignSelf: 'center',
		width: '100%',
	},
	ButtonsHolder: {
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'row-reverse',
		...Platform.select({ web: { gap: 12 }, native: { marginBottom: 16 } }),
	},
	filledButton: {
		backgroundColor: colors.primary,
		...Platform.select({ native: { marginLeft: 12 } }),
	},
	filledGreenButton: {
		backgroundColor: colors.greenClock,
		...Platform.select({ native: { marginLeft: 12 } }),
	},
	outlinedButton: {
		borderWidth: 1,
		borderColor: colors.titlePrimary,
	},
	report101Container: {
		display: 'flex',
		flexDirection: 'column-reverse',
		alignItems: 'center',
		marginTop: 30,
	},
	report101Text: {
		display: 'flex',
		marginBottom: 5,
	},
	report101ActionsContainer: {},
	report101Button: {
		alignSelf: 'center',
		height: 40,
		width: 196,
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: 50,
	},
	sectionHeaderRow: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		...Platform.select({ web: { marginBottom: 8 }, ios: { marginBottom: 24 }, android: { marginBottom: 24 } }),
	},
	dividerLine: {
		height: 1,
		backgroundColor: '#E0E0E0',
		marginBottom: 8,
	},
	columnHeaderRow: {
		flexDirection: 'row',
		alignItems: 'center',
		paddingVertical: 6,
		borderBottomWidth: 1,
		borderBottomColor: '#E0E0E0',
	},
	columnHeader: {
		flex: 1,
		alignItems: 'center',
	},
	totalRow: {
		flexDirection: 'row',
		alignItems: 'center',
		paddingVertical: 8,
		borderTopWidth: 1,
		borderTopColor: '#E0E0E0',
	},
	emptyState: {
		alignItems: 'center',
		justifyContent: 'center',
		paddingVertical: 40,
		...Platform.select({ web: { gap: 24 } }),
	},
	compactRecordsButton: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		paddingVertical: 10,
		marginTop: 4,
		alignSelf: 'center',
	},
	sheetBackdrop: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0,0,0,0.35)',
	},
	sheetHeader: {
		backgroundColor: colors.white,
		borderTopLeftRadius: 16,
		borderTopRightRadius: 16,
		alignItems: 'center',
		paddingTop: 8,
		paddingBottom: 12,
		paddingHorizontal: 16,
		zIndex: 11,
	},
	sheetHandle: {
		width: 40,
		height: 4,
		borderRadius: 2,
		backgroundColor: '#D0D0D0',
		marginBottom: 12,
	},
	sheetTitleRow: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
	},
	sheetContent: {
		backgroundColor: colors.white,
		paddingHorizontal: 20,
		paddingVertical: 24,
		height: Dimensions.get('window').height * 0.7 - 64,
		...Platform.select({ web: { gap: 16 } }),
	},
	sheetRecordsList: {
		flex: 1,
		minHeight: 0,
		...Platform.select({ ios: { marginBottom: 16 }, android: { marginBottom: 16 } }),
	},
	recordRow: {
		flexDirection: 'column',
		alignItems: 'center',
		width: '100%',
		padding: 12,
		borderWidth: 1,
		borderRadius: 8,
		borderColor: colors.iconBG,
		marginBottom: 12,
	},
	headerCard: {
		alignItems: 'center',
		justifyContent: 'space-between',
		flexDirection: 'row-reverse',
		width: '100%',
		marginBottom: 8,
	},
	body: {
		width: '100%',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
	},
	cell: {
		flex: 1,
		alignItems: 'center',
	},
	editCell: {
		width: 40,
		alignItems: 'center',
		justifyContent: 'center',
	},
});
export default ClockReportMobileComponent;
